import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Button,
  Row,
  Typography,
  Layout,
  Image,
  Card,
  Spin,
  Input,
  message,
  List,
} from "antd";
import { useNavigate, useParams } from "react-router";
import { UPLOADS_URL, COURSE, LECTURE } from "../../config/constants/api";
import { Get } from "../../config/api/get";
import swal from "sweetalert";
import VideoPlayer from "../../components/VideoPlayer";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";

import "react-alice-carousel/lib/alice-carousel.css";

function LectureDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const [reviews, setReviews] = useState([]);
  const [ratings, setRatings] = useState({});
  const [lecture, setLecture] = useState({});
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const { Search } = Input;
  const [loading, setLoading] = useState(true);
  const [lectures, setLectures] = useState([]);
  const [range, setRange] = useState([10, 200]);
  const [review, setReview] = useState({
    averageRating: 0,
    totalReviews: 0,
  });
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);

  const item = { rating: 4 };

  useEffect(() => {
    getLectureDetails();
  }, []);

  // Reset selected video when lecture data loads
  useEffect(() => {
    if (lecture?.lecture) {
      setSelectedVideoIndex(0);
    }
  }, [lecture?.lecture]);

  const getLectureDetails = async () => {
    try {
      const response = await Get(LECTURE.getLectureById + id, token);
      if (response?.status) {
        setLecture(response?.data);
      } else {
        swal("Error", response?.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };
  console.log("Lecture Details", lecture);
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Row
        className="blueBackground"
        style={{
          height: "45vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Typography.Title
          className="fontFamily1"
          style={{
            fontSize: "30px",
            color: "#333d47",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          {/* {<> Instructor Led Traning Details</>} */}
          {<> On Demand Courses</>}
        </Typography.Title>
      </Row>

      {/* section 2 */}
      <Row
        className="whiteBackground"
        style={{
          backgroundColor: "white",
          justifyContent: "center",
          padding: "50px 20px",
        }}
        gutter={[20, 20]}
      >
        <Col xs={24}>
          <div style={{ marginBottom: 20, marginLeft: 10 }}>
            <FaArrowLeft
              style={{ marginRight: 8, fontSize: "20px", cursor: "pointer" }}
              onClick={() => navigate(-1)}
            />
          </div>
        </Col>

        {loading && (
          <Col xs={24}>
            <Row style={{ minHeight: "30vh" }} className="flex" justify="center">
              <Spin size="large" />
            </Row>
          </Col>
        )}

        {!loading && (
          <>
            {/* Video Section - Two Column Layout */}
            {(lecture?.lecture?.fileUrls?.length > 0 || lecture?.lecture?.fileUrl) && (
              <Col xs={24}>
                <Row gutter={[20, 20]}>
                  {/* Left Column - Video List */}
                  <Col xs={24} lg={8}>
                    <Card
                      className="contactCard2"
                      bordered={false}
                      style={{ height: "100%" }}
                    >
                      <Typography.Title
                        className="fontFamily1"
                        style={{
                          fontSize: "24px",
                          fontWeight: 800,
                          color: "black",
                          textAlign: "left",
                          marginBottom: 15,
                        }}
                      >
                        {lecture?.lecture?.title}
                      </Typography.Title>
                      <Typography.Text
                        className="fontFamily1"
                        style={{
                          fontSize: "14px",
                          color: "grey",
                          textAlign: "justify",
                          marginBottom: 25,
                          display: "block",
                        }}
                      >
                        {lecture?.lecture?.description}
                      </Typography.Text>
                      <Typography.Title
                        className="fontFamily1"
                        style={{
                          fontSize: "20px",
                          fontWeight: 800,
                          color: "black",
                          textAlign: "left",
                          marginBottom: 20,
                        }}
                      >
                        Videos
                      </Typography.Title>
                      {lecture?.lecture?.fileUrls?.length > 0 ? (
                        <div 
                          style={{ 
                            display: "flex", 
                            flexDirection: "column", 
                            gap: 10,
                            maxHeight: "500px",
                            overflowY: "auto",
                            paddingRight: "5px",
                          }}
                        >
                          {lecture.lecture.fileUrls.map((fileUrl, index) => {
                            const thumbnail = lecture?.lecture?.videoThumbnails?.[index] 
                              || lecture?.lecture?.thumbnail 
                              || lecture?.lecture?.images?.[0];
                            return (
                              <Card
                                key={index}
                                hoverable
                                style={{
                                  cursor: "pointer",
                                  border: selectedVideoIndex === index ? "2px solid #00a79d" : "1px solid #d9d9d9",
                                  backgroundColor: selectedVideoIndex === index ? "#f0f9f8" : "white",
                                }}
                                onClick={() => setSelectedVideoIndex(index)}
                                bodyStyle={{ padding: "15px" }}
                              >
                                <Row gutter={10} align="middle">
                                  <Col span={6}>
                                    {thumbnail ? (
                                      <Image
                                        src={UPLOADS_URL + "/" + thumbnail}
                                        width="100%"
                                        height={60}
                                        preview={false}
                                        style={{ borderRadius: "5px", objectFit: "cover" }}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          width: "100%",
                                          height: 60,
                                          backgroundColor: "#f0f0f0",
                                          borderRadius: "5px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <FaArrowRight style={{ color: "#00a79d", fontSize: "20px" }} />
                                      </div>
                                    )}
                                  </Col>
                                  <Col span={18}>
                                    <Typography.Text
                                      className="fontFamily1"
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: selectedVideoIndex === index ? 700 : 500,
                                        color: selectedVideoIndex === index ? "#00a79d" : "black",
                                      }}
                                    >
                                      Video {index + 1}
                                    </Typography.Text>
                                  </Col>
                                </Row>
                              </Card>
                            );
                          })}
                        </div>
                      ) : (
                        <Card
                          hoverable
                          style={{
                            cursor: "pointer",
                            border: "2px solid #00a79d",
                            backgroundColor: "#f0f9f8",
                          }}
                          bodyStyle={{ padding: "15px" }}
                        >
                          <Row gutter={10} align="middle">
                            <Col span={6}>
                              {lecture?.lecture?.thumbnail ? (
                                <Image
                                  src={UPLOADS_URL + "/" + lecture?.lecture?.thumbnail}
                                  width="100%"
                                  height={60}
                                  preview={false}
                                  style={{ borderRadius: "5px", objectFit: "cover" }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: "100%",
                                    height: 60,
                                    backgroundColor: "#f0f0f0",
                                    borderRadius: "5px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <FaArrowRight style={{ color: "#00a79d", fontSize: "20px" }} />
                                </div>
                              )}
                            </Col>
                            <Col span={18}>
                              <Typography.Text
                                className="fontFamily1"
                                style={{
                                  fontSize: "16px",
                                  fontWeight: 700,
                                  color: "#00a79d",
                                }}
                              >
                                Video 1
                              </Typography.Text>
                            </Col>
                          </Row>
                        </Card>
                      )}
                    </Card>
                  </Col>

                  {/* Right Column - Video Player */}
                  <Col xs={24} lg={16}>
                    <Card className="contactCard2" bordered={false}>
                      <div style={{ width: "100%" }}>
                        {lecture?.lecture?.fileUrls?.length > 0 ? (
                          <VideoPlayer
                            data={lecture?.lecture}
                            index={selectedVideoIndex}
                          />
                        ) : (
                          <VideoPlayer data={lecture?.lecture} />
                        )}
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Col>
            )}

            {/* Show thumbnail if no videos */}
            {!lecture?.lecture?.fileUrls?.length && !lecture?.lecture?.fileUrl && lecture?.lecture?.thumbnail && (
              <Col xs={24}>
                <Card className="contactCard2" bordered={false}>
                  <div style={{ width: "100%", marginBottom: 20 }}>
                    <Image
                      src={UPLOADS_URL + "/" + lecture?.lecture?.thumbnail}
                      width={"100%"}
                      height={350}
                      preview={false}
                      style={{ borderRadius: "10px", objectFit: "cover" }}
                    />
                  </div>
                </Card>
              </Col>
            )}

            {/* Lecture Details Section */}
            <Col xs={24}>
              <Card className="contactCard2" bordered={false}>
                <Row
                  style={{
                    width: "100%",
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                  }}
                >

                  {lecture?.lecture?.files?.length > 0 && (
                    <div style={{ width: "100%", marginTop: 30 }}>
                      <Typography.Title
                        className="fontFamily1"
                        style={{
                          fontSize: "20px",
                          fontWeight: 800,
                          color: "black",
                          textAlign: "left",
                          marginBottom: 15,
                        }}
                      >
                        Documents
                      </Typography.Title>
                      <RecordViewer pdfLinks={lecture?.lecture?.files} />
                    </div>
                  )}

                  {lecture?.lecture?.images?.length > 0 && (
                    <div style={{ width: "100%", marginTop: 30 }}>
                      <Typography.Title
                        className="fontFamily1"
                        style={{
                          fontSize: "20px",
                          fontWeight: 800,
                          color: "black",
                          textAlign: "left",
                          marginBottom: 15,
                        }}
                      >
                        Images
                      </Typography.Title>
                      <RecordViewer pdfLinks={lecture?.lecture?.images} />
                    </div>
                  )}

                  {lecture?.quizzes && lecture?.quizzes?.length > 0 && (
                    <div style={{ marginTop: 30, width: "100%" }}>
                      <Typography.Title
                        className="fontFamily1"
                        style={{
                          fontSize: "20px",
                          fontWeight: 800,
                          color: "black",
                          textAlign: "left",
                        }}
                      >
                        Lecture Quizzes (Total: {lecture?.quizzes?.length})
                      </Typography.Title>
                      <List
                        bordered
                        dataSource={lecture?.quizzes}
                        renderItem={(quiz, index) => (
                          <List.Item
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              cursor: "pointer",
                              gap: "15px",
                            }}
                            onClick={() => navigate("/quiz-details/" + quiz._id)}
                          >
                            <Button
                              type="primary"
                              shape="circle"
                              size="small"
                              style={{
                                backgroundColor: "#00a79d",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexShrink: 0,
                              }}
                              icon={<FaArrowRight style={{ color: "white", fontSize: "12px" }} />}
                            />
                            <div>
                              <Typography.Text
                                className="fontFamily1"
                                style={{
                                  fontSize: "16px",
                                  fontWeight: 600,
                                  color: "black",
                                }}
                              >
                                {index + 1}. {quiz?.title || "Quiz"}
                              </Typography.Text>
                              <br />
                              <Typography.Text
                                className="fontFamily1"
                                style={{
                                  fontSize: "14px",
                                  color: "grey",
                                }}
                              >
                                {quiz?.description?.slice(0, 80)}
                                {quiz?.description?.length > 80 && "..."}
                              </Typography.Text>
                            </div>
                          </List.Item>
                        )}
                      />
                    </div>
                  )}

                  {token && lectures.includes(lecture?.lecture?._id) && (
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="loginButton"
                      style={{ marginTop: 30 }}
                      onClick={() =>
                        navigate("/payment/" + lecture?.lecture?._id, {
                          state: { type: "COURSE" },
                        })
                      }
                    >
                      Register Now
                    </Button>
                  )}
                </Row>
              </Card>
            </Col>
          </>
        )}
      </Row>
    </Layout>
  );
}

export default LectureDetails;

const RecordViewer = ({ pdfLinks }) => {
  return (
    <List
      bordered
      dataSource={pdfLinks}
      renderItem={(item) => (
        <List.Item>
          <a
            href={UPLOADS_URL + "/" + item}
            target="_blank"
            rel="noopener noreferrer"
          >
            {(item.split(".")[1] || "") +
              (item.split(".")[2] ? "." + item.split(".")[2] : item)}
          </a>
        </List.Item>
      )}
    />
  );
};
